function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5509 29.4221C14.1882 29.793 13.6933 30 13.1792 30C12.6651 30 12.1702 29.793 11.8075 29.4221L0.852655 18.2822C-0.284218 17.1263 -0.284218 15.2519 0.852655 14.0982L2.22436 12.7032C3.36159 11.5473 5.20297 11.5473 6.33985 12.7032L13.1792 19.6573L31.6602 0.866916C32.7974 -0.288972 34.6405 -0.288972 35.7756 0.866916L37.1473 2.26193C38.2842 3.41782 38.2842 5.2918 37.1473 6.44588L14.5509 29.4221Z",
  fill: "current"
});

function SvgIcFeatureCarouselFive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFeatureCarouselFive);
export default __webpack_public_path__ + "static/media/ic_feature_carousel_five.c389a9b7.svg";
export { ForwardRef as ReactComponent };